module.exports = __webpack_public_path__ + "static/img/noppakao-logo.8d73336.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/noppakao-logo.jpg
// module id = OYG1
// module chunks = 3